export default ({ request }) => ({
  changeOrderInfoDetailApi(data = {}) {
    return request({
      url: '/factory/changeOrderInfo/detail',
      method: 'post',
      data,
    })
  },
  changeOrderInfoPartDetailApi(data = {}) {
    return request({
      url: '/factory/changeOrderInfo/part/detail',
      method: 'post',
      data,
    })
  },
  changeOrderInfoEditApi(data = {}) {
    return request({
      url: '/factory/changeOrderInfo/edit/save',
      method: 'post',
      data,
    })
  },
})
